import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "nav-item" }
const _hoisted_2 = {
  key: 0,
  class: "fas fa-power-off"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InertiaLink = _resolveComponent("InertiaLink")
  const _component_LinkVue = _resolveComponent("LinkVue")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.notALink)
      ? (_openBlock(), _createBlock("a", {
          key: 0,
          href: _ctx.targetUrl || undefined,
          class: ["nav-link text text--size-18 text--height-14 text--center text--primary-b text--semi-bold", { 'text--uppercase': _ctx.uppercase }]
        }, _toDisplayString(_ctx.title), 11, ["href"]))
      : (_ctx.isActiveRoute)
        ? (_openBlock(), _createBlock("a", {
            key: 1,
            href: "#",
            class: ["nav-link text text--size-18 text--height-14 text--center text--primary-b text--semi-bold", { active: _ctx.isActiveRoute, 'text--uppercase': _ctx.uppercase }],
            "aria-current": _ctx.$page.url === '/' ? 'page' : undefined,
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.scrollToTop && _ctx.scrollToTop(...args)), ["prevent"]))
          }, _toDisplayString(_ctx.title), 11, ["aria-current"]))
        : (_ctx.inertiaLinkObj)
          ? (_openBlock(), _createBlock(_component_InertiaLink, {
              key: 2,
              class: ["nav-link text text--size-18 text--height-14 text--center text--primary-b text--semi-bold flex flex--valign-c flex--gap-8", { 'text--secondary-b': _ctx.inertiaLinkObj.inertiaPowerOff }],
              as: _ctx.inertiaLinkObj.inertiaAs,
              method: _ctx.inertiaLinkObj.inertiaMethod,
              href: _ctx.targetUrl
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
                (_ctx.inertiaLinkObj.inertiaPowerOff)
                  ? (_openBlock(), _createBlock("span", _hoisted_2))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["class", "as", "method", "href"]))
          : (_openBlock(), _createBlock(_component_LinkVue, {
              key: 3,
              href: _ctx.targetUrl || undefined,
              class: ["nav-link text text--size-18 text--height-14 text--center text--primary-b text--semi-bold", { active: _ctx.$page.url === _ctx.pageRoute, 'text--uppercase': _ctx.uppercase }],
              "aria-current": _ctx.$page.url === '/' ? 'page' : undefined,
              "preserve-scroll": false,
              "preserve-state": false
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.title), 1)
              ]),
              _: 1
            }, 8, ["href", "class", "aria-current"]))
  ]))
}